import { render, staticRenderFns } from "./CollectionDetails.vue?vue&type=template&id=5a798a7f&"
import script from "./CollectionDetails.vue?vue&type=script&lang=js&"
export * from "./CollectionDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports